export const PUBSUB_TOPICS = {
  PEER_DISCOVERY: '/p2p/peer-discovery/1.0.0',
  FILE_TRANSFER: 'file-transfer-libp2p',
  FILE_LIST: '/p2p/file-list/1.0.0',
  HAP_FILE_ANNOUNCE: '/p2p/hap-file-announce/1.0.0',
  FILE_UPLOADED: '/p2p/hap-file-announce/1.0.0',
  FILES_UPDATED: '/p2p/file-list/1.0.0',
  TOPIC_LIST: '/p2p/topic-list/1.0.0',
  SIX_ID_ANNOUNCE: '/p2p/six-id-announce/1.0.0',
  MESH_HEARTBEAT: '/p2p/mesh-heartbeat/1.0.0',
  ORG_GLOBAL: '/p2p/org-global/1.0.0',
  SIX: (sixId: string) => `/p2p/six/${sixId}/1.0.0`,
};

export const FILE_TRANSFER_TOPIC = PUBSUB_TOPICS.FILE_TRANSFER;
export const FILE_LIST_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.FILE_LIST}/${sixId}`;
export const TOPIC_LIST_TOPIC = PUBSUB_TOPICS.TOPIC_LIST;
export const HAP_FILE_ANNOUNCE_TOPIC = (sixId: string) =>
  `${PUBSUB_TOPICS.HAP_FILE_ANNOUNCE}/${sixId}`;
export const MESH_HEARTBEAT_TOPIC = PUBSUB_TOPICS.MESH_HEARTBEAT;
export const FILE_UPLOADED_TOPIC = (sixId: string) =>
  `${PUBSUB_TOPICS.FILE_UPLOADED}/${sixId}`;
export const FILES_UPDATED_TOPIC = (sixId: string) =>
  `${PUBSUB_TOPICS.FILES_UPDATED}/${sixId}`;
export const SIX_TOPIC = (sixId: string) => PUBSUB_TOPICS.SIX(sixId);
export const ORG_GLOBAL_TOPIC = PUBSUB_TOPICS.ORG_GLOBAL;
